<template>
  <ValidationObserver
    @submit.prevent="handleSubmit"
    v-slot="validation"
    ref="observer"
    tag="form"
  >
    <slot v-bind:validation="validation" />
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate'

export default {
  name: 'base-form',

  components: { ValidationObserver },

  props: {
    submit: { type: Function, required: true }
  },

  methods: {
    handleSubmit() {
      return this.$refs.observer.validate().then(isValid => {
        if (!isValid) return
        this.submit()
      })
    }
  }
}
</script>
